import { render, staticRenderFns } from "./DomainsTransferList.vue?vue&type=template&id=674064f8&"
import script from "./DomainsTransferList.vue?vue&type=script&lang=js&"
export * from "./DomainsTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674064f8')) {
      api.createRecord('674064f8', component.options)
    } else {
      api.reload('674064f8', component.options)
    }
    module.hot.accept("./DomainsTransferList.vue?vue&type=template&id=674064f8&", function () {
      api.rerender('674064f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainsTransferList.vue"
export default component.exports